import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';
import lang from '../../constants/Languages.js';

//import components
import ItemText from './ItemText.js';

const ItemSubSectionSeparate = ({ clang, desc, list }) => {
    return (
        <div className="item__subsection--separate">
            {list.map((listItem, listItemIndex) =>
                <div key={listItemIndex}>
                    {listItem.year &&
                        <div className="item__subsection">
                            <div className="item__subsection-content">
                                <ItemText
                                    text={listItem.year.label}
                                    type={listItem.year.entityType}
                                    link={listItem.year.link}/>
                                <ItemText text={listItem.year.description}/>
                            </div>
                        </div>}
                    {listItem.broadcasts &&
                        <div className="item__subsection">
                            <label className="item__subsection-label">
                                <span className="item__subsection-label__inner">{lang[clang].item.types['resumptionsBroadcasts']}</span>:
                            </label>
                            <div className="item__subsection-content">
                                {listItem.broadcasts.map((item, index) =>
                                    <div key={index} className="item__separate__item">
                                        <ItemText text={`${item} ${index !== listItem.broadcasts.length - 1 ? ';' : ''}`}/>
                                        {/* {index !== listItem.broadcasts.length - 1 ? <span>;</span> : null} */}
                                    </div>)}
                            </div>
                        </div>}
                    {listItem.program &&
                        <div className="item__subsection">
                            <label className="item__subsection-label">
                                <span className="item__subsection-label__inner">{lang[clang].item.types['resumptionsProgram']}</span>:
                            </label>
                            <div className="item__subsection-content">
                                <ItemText text={listItem.program}/>
                            </div>
                        </div>}
                    {!listItem.year && !listItem.broadcasts && !listItem.program &&
                        <div className="item__subsection">
                            <div className="item__subsection-content">
                                <ItemText
                                    text={listItem.label}
                                    type={listItem.entityType}
                                    link={listItem.link}/>
                                <ItemText text={listItem.description}/>
                            </div>
                        </div>}
                    {listItemIndex !== list.length - 1 &&
                        <div className="item__subsection">
                            <label className="item__subsection-label__separator">
                            </label>
                            <div className="item__subsection-content">
                            </div>
                        </div>}
                </div>)}
        </div>
    );
};

ItemSubSectionSeparate.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemSubSectionSeparate);



// WEBPACK FOOTER //
// ./src/components/items/ItemSubSectionSeparate2.js